// React is used implicitly for JSX

export default function Settings() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Settings</h1>
      <p>Your settings page content will go here.</p>
    </div>
  )
}